import { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';
import ComponentCard from '../../layouts/containers/ComponentCard';
import ResumenSol from '../../components/matriculas/solicitudes/ResumenSol';
import HistorialMatricula from '../../components/matriculas/solicitudes/HistorialMatricula';
import { SearchMatContext } from '../../context/searchMatContext';
import matriculacionApiService from '../../services/http/matriculacionApiService';
import { getItem, setItem, removeItem, STORAGE_KEYS } from '../../services/storage';

const Revision = (props) => {
  const { matriculaId: id, empresaId: headquarter } = useParams();

  const [idUsuario, setIdUsuario] = useState('');
  const [nombreAlumno, setNombreAlumno] = useState('');
  const [dataCharged, setDataCharged] = useState(false);
  const navigate = useNavigate();
  const { saveSearches, searchMatState } = useContext(SearchMatContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataMatricula = await matriculacionApiService.getMatriculaById(id, { headquarter });

        if (getItem(STORAGE_KEYS.ENROLLMENT)) removeItem(STORAGE_KEYS.ENROLLMENT);
        setItem(STORAGE_KEYS.ENROLLMENT, dataMatricula);
        setDataCharged(true);
      } catch (error) {
        setDataCharged(false);
      }
    };

    fetchData();
  }, [headquarter, id]);

  // Actualizar título de la pestaña
  useEffect(() => {
    if (nombreAlumno) {
      document.title = `Admin - ${nombreAlumno}`;
    }

    // Limpiar el título cuando se desmonte el componente
    return () => {
      document.title = 'Admin';
    };
  }, [nombreAlumno]);

  if (!dataCharged) return null;

  const handleClick = () => {
    const search = searchMatState;

    search.newSearch = false;
    saveSearches(search);
    navigate('/solicitudes-matricula');
  };

  return (
    <>
      <Col md="12">
        <ComponentCard
          title={`Revisión de solicitud - ${headquarter} - ${id} - Creado por  - ${idUsuario}`}
          hasButton={false}
          handleClick={handleClick}
          dropdown
        >
          <ResumenSol
            tipo={props.tipo}
            idMatricula={id}
            setIdUsuario={setIdUsuario}
            setNombreAlumno={setNombreAlumno}
            handleOnClick={handleClick}
          />
        </ComponentCard>
        <HistorialMatricula headquarter={headquarter} id={id} entidad="matricula" />
      </Col>
    </>
  );
};

Revision.propTypes = {
  tipo: PropTypes.number,
};

export default Revision;
